<div class="newtable-wrapper">
    <p-table
        #dt
        *ngIf="showTable"
        class="pr-table"
        [columns]="columns"
        [value]="tableData"
        [paginator]="true"
        [rows]="perPage"
        [rowsPerPageOptions]="[perPage]"
        [scrollable]="true"
        [(selection)]="selected"
        (onPage)="onPage($event)"
        [resizableColumns]="true"
        [reorderableColumns]="true"
        stateStorage="local"
        [stateKey]="tableId"
        dataKey="{{this.idFieldName}}"
        selectionMode="multiple"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="od {first} do {last} z {totalRecords}"
    >
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col
                    *ngFor="let col of columns"
                    [style.width]="col?.width + '%'"
                >
            </colgroup>
        </ng-template>

        <ng-template pTemplate="caption">
            <div class="table-header" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row"
                     fxLayoutAlign="center center"
                     fxFlex
                     fxLayoutGap="10px"
                >
                    <div fxFlex="none">
                        <button mat-button (click)="resetTable()">
                            <mat-icon
                                class="text-primary"
                            >
                                settings_backup_restore
                            </mat-icon>
                        </button>
                    </div>

                    <div class="title" fxFlex="none"
                         fxLayoutAlign="center center">
                        <p class="upper bold-font mat-body-2" style="font-size: 20px; max-width: 110px;" *ngIf="title">{{title}}</p>
                    </div>

                    <div
                        class="search-wrapper"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        fxFlex
                    >
                        <input
                            matInput
                            #filter
                            placeholder="Wpisz szukaną frazę"
                            class="search-bar"
                            [formControl]="filterGlobalControl"
                            (keyup.enter)="dt.filterGlobal(filterGlobalControl.value, 'contains')"
                        />
                        <mat-icon class="text-primary" (click)="clearGlobalFilter()">close</mat-icon>
                        <mat-icon
                            class="text-primary"
                            (click)="dt.filterGlobal(filterGlobalControl.value, 'contains')"
                        >
                            search
                        </mat-icon>
                    </div>

                    <div class="cc-table-action" fxLayout="row">
                        <button type="button" (click)="removeSelectedItems()" class="butt-bad">
                            <p class="upper">usuń wybrane</p>
                        </button>
                        <button type="button" (click)="removeAllItems()" class="butt-bad ml-xxs">
                            <p class="upper">usuń wszystkie({{tableData.length}})</p>
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
            <tr>
                <th
                    *ngFor="let col of columns"
                    [pSortableColumn]="(col.field !== 'selectedField' && col.field !== 'removeField') ? col.field : null"
                    pResizableColumn
                    pReorderableColumn
                    style="position: relative;"
                >
                    <ng-container *ngIf="col.field === 'selectedField'">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </ng-container>

                    <ng-container *ngIf="col.field !== 'selectedField'">
                        {{ col.header }}
                        <p-sortIcon *ngIf="col.showSort !== false" [field]="col.field"></p-sortIcon>

                        <pr-select-by-column
                            [column]="col"
                            [dt]="dt"
                        ></pr-select-by-column>
                    </ng-container>
                </th>
            </tr>
            <!--            <tr>-->
            <!--                <th *ngFor="let col of columns" [ngSwitch]="col.dataType">-->
            <!--                    <input-->
            <!--                        *ngIf="col.showSearch !== false"-->
            <!--                        pInputText-->
            <!--                        type="text"-->
            <!--                        (input)="-->
            <!--                            dt.filter(-->
            <!--                                $event.target.value,-->
            <!--                                col.field,-->
            <!--                                'contains'-->
            <!--                            )-->
            <!--                        "-->
            <!--                        class="searchColumnText p-column-filter"-->
            <!--                    />-->
            <!--                </th>-->
            <!--            </tr>-->
        </ng-template>

        <ng-template pTemplate="body" let-row let-columns="columns">
            <tr>
                <td
                    [ngClass]="'pr-table-coltype-' + column.dataType"
                    class="ui-resizable-column"
                    *ngFor="let column of columns"
                >
                    <ng-container *ngIf="column.field === 'selectedField'">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <p-tableCheckbox [value]="row"></p-tableCheckbox>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="column.field === 'removeField'">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <mat-icon class="text-primary" aria-label="Add" (click)="removeRow(row)">remove</mat-icon>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="column.field === 'Coefficent'">
                        <div class="ph-xxs table-input flex" fxLayout="row" fxLayoutAlign="center center">
                            <input
                                style="width: 100%"
                                class="table-input"
                                [class.incorrect-input]="checkInputConfIncorrect(row[column.field])"
                                type="number" step="any"
                                [(ngModel)]="row[column.field]"
                            />
                        </div>
                    </ng-container>

                    <ng-container *ngIf="column.field === 'LowerIndex'">
                        <div class="pl-xxs flex table-input" fxLayout="row" fxLayoutAlign="center center">
                            <input
                                class="table-input"
                                style="width: 100%"
                                [class.incorrect-input]="checkInputMinIncorrect(row['LowerIndex'], row['TopIndex'])"
                                type="number" step="any"
                                [(ngModel)]="row[column.field]"
                            />
                            <span class="mr-xxs" style="margin-left: 3px;">%</span>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="column.field === 'TopIndex'">
                        <div class="pl-xxs flex table-input" fxLayout="row" fxLayoutAlign="center center">
                            <input
                                class="table-input"
                                style="width: 100%"
                                type="number"
                                [class.incorrect-input]="checkInputMaxIncorrect(row['LowerIndex'], row['TopIndex'])"
                                [(ngModel)]="row[column.field]"
                            />
                            <span class="mr-xxs" style="margin-left: 3px;">%</span>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="column.field === 'RelationName'">
                        <div class="ph-xxs flex table-input" fxLayout="row" fxLayoutAlign="center center">
                            <input
                                style="width: 100%"
                                [(ngModel)]="row[column.field]"
                                [class.incorrect-input]="!row[column.field]"
                                class="table-input"
                            />
                        </div>
                    </ng-container>

                    <ng-container *ngIf="column.field === 'Name' || column.field === 'CategoryLevel1Name' || column.field === 'Ean'">

                        <div *ngIf="column.type && column.type === 'date'" [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled">
                            {{
                            generalService.parseDate(row[column.field]) ||
                            '-'
                            }}
                        </div>
                        <div *ngIf="column.type && column.type === 'datetime'" [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled">
                            {{
                            generalService.parseDateWithTime(
                                row[column.field]
                            ) || '-'
                            }}
                        </div>
                        <div
                            *ngIf="column.type && column.type === 'vat'"
                            [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled"
                            class="percentage-suf"
                        >
                            {{
                            generalService.parseVAT(row[column.field])
                                | number: '.0-0'
                            }}
                        </div>
                        <div *ngIf="column.type && column.type === 'number'" [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled">
                            {{ row[column.field] || '-' }}
                        </div>
                        <div *ngIf="!column.suffix && !column.type" [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled">
                            {{ row[column.field] || '-' }}
                        </div>
                        <div
                            *ngIf="column.type && column.type === 'margin'"
                            [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled"
                            class="percentage-suf"
                        >
                            {{
                            generalService.parseVAT(row[column.field])
                                | number: '.1-1'
                            }}
                        </div>
                        <div
                            *ngIf="
                            !column.type &&
                            column.suffix &&
                            column.suffix === 'percentage'
                        "
                            [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled"
                            class="percentage-suf"
                        >
                            {{ row[column.field] || '-' }}
                        </div>
                        <div
                            *ngIf="column.suffix && column.suffix === 'currency'"
                            [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled"
                            class="currency-suf"
                        >
                            {{ (row[column.field] | number: '.2-2') || '-' }}
                        </div>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
